<template>

<canvas ref="canvas" width="100%" height="250px"></canvas>

</template>

<script>
import {Bar} from 'vue-chartjs'

export default {
  extends: Bar,
  name: 'facetrangechart',
  props: [ 'facet', 'facetname' ],
  data () {
    return {
      datacollection: {
        labels: [],
        datasets: [{
          backgroundColor: [
            '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba',
            '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba',
            '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba',
            '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba', '#2d97ba'],
          data: [],
          actions: []
        }],
        st: this.$store
      }
    }
  },
  mounted () {
    this.renderChart(
      this.datacollection,
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.facetname
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        onClick: function (evt, item) {
          if (item[0] && item[0]._chart &&
              item[0]._chart.data.st) {
            // TODO: item[0]._chart.data.st.dispatch('fetchSearchResponse', item[0]._chart.data.datasets[0].actions[item[0]._index]);
          }
        }
      })
  },
  watch: {
    facet: function () { // watch it
      this.datacollection.labels = [];
      this.datacollection.datasets[0].data = [];
      this.datacollection.datasets[0].actions = [];

      for (var key in this.facet.groupedCounts) {
        this.datacollection.labels.push(key);
        this.datacollection.datasets[0].data.push(this.facet.groupedCounts[key].count);
        this.datacollection.datasets[0].actions.push(this.facet.groupedCounts[key].sem_action.sem_url_action);
      }

      this.renderChart(this.datacollection, {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.facetname
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        onClick: function (evt, item) {
          if (item[0] && item[0]._chart &&
                  item[0]._chart.data.st) {
            // TODO: item[0]._chart.data.st.dispatch('fetchSearchResponse', item[0]._chart.data.datasets[0].actions[item[0]._index]);
          }
        }
      });
    }
  },
  created: function () {
    for (var key in this.facet.groupedCounts) {
      this.datacollection.labels.push(key);
      this.datacollection.datasets[0].data.push(this.facet.groupedCounts[key].count);
      this.datacollection.datasets[0].actions.push(this.facet.groupedCounts[key].sem_action.sem_url_action);
    }
  },

  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response : null;
    },
    facets () {
      if (this.$store.state.response &&
          this.$store.state.response.facet_counts &&
          this.$store.state.response.facet_counts.facet_ranges) {
        return this.$store.state.response.facet_counts.facet_ranges
      }
      return null;
    }
  }
}
</script>

<style scoped>

</style>
